module.exports = __webpack_public_path__ + "img/20200113155745278.0097542e.jpg";